import api from "@/api/client";

const BASE = "/word-bank";

/**
 * Fetch word bank entries
 * @param {Object} [filters] - {scope, entity, active, createdBy}
 */
export const getWordBank = async (filters = {}) => {
  const params = {};

  if (filters.scope !== undefined) {
    params.scope = filters.scope;
  }

  if (filters.entityId !== undefined) {
    params.entityId = filters.entityId;
  }

  if (filters.active !== undefined) {
    params.active = filters.active;
  }

  if (filters.createdBy !== undefined) {
    params.createdBy = filters.createdBy;
  }

  const { data } = await api.get(BASE);

  return data;
};

/**
 * Create one or more words
 * @param {{words: Array<{word, tier, scope?, entityId}>}} dto
 */
export const createWords = async (dto) => {
  const { data } = await api.post(BASE, dto);
  return data;
};

/**
 * Update a word by ID
 * @param {string} id
 * @param {{updates: {word?, tier?, scope?, entityId? }}} dto
 */
export const updateWord = async (id, dto) => {
  const { data } = await api.patch(`${BASE}/${id}`, dto);

  return data;
};

/**
 * Delete a word by ID
 * @param {string} id
 */
export const deleteWord = async (id) => {
  const { data } = await api.delete(`${BASE}/${id}`);
  return data;
};
